import { useState, useEffect } from 'react';
import { C } from './constants';

/**
 * Animated SVG ring gauge.
 * Renders a circular progress indicator with stroke-dashoffset animation.
 *
 * @param {number} val - Value 0-100
 * @param {string} color - Stroke color
 * @param {number} [sz=120] - Diameter in px
 * @param {number} [sw=3] - Stroke width
 * @param {React.ReactNode} children - Center content
 */
export const Ring = ({ val, color, sz = 120, sw = 3, children }) => {
  const r = (sz - sw) / 2;
  const ci = 2 * Math.PI * r;
  const [off, setOff] = useState(ci);

  useEffect(() => {
    const id = setTimeout(() => setOff(ci - (val / 100) * ci), 50);
    return () => clearTimeout(id);
  }, [val, ci]);

  return (
    <div style={{ position: 'relative', width: sz, height: sz }}>
      <svg width={sz} height={sz} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={sz / 2} cy={sz / 2} r={r} fill="none" stroke={C.border} strokeWidth={sw} />
        <circle
          cx={sz / 2} cy={sz / 2} r={r} fill="none" stroke={color} strokeWidth={sw}
          strokeDasharray={ci} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 1.4s cubic-bezier(.16,1,.3,1)' }}
        />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        {children}
      </div>
    </div>
  );
};
